import React, { useState, useEffect } from "react";
import axios from "axios";
import Breadcrumb from "../../components/breadcrumb/index";
import DataTable_Component from "../../components/DataTable/index";
import Status_modal from "../../components/manageInvoice/status_modal/index";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import Layouts from "../../layouts/layouts";
import RegisterDetailModal from "../../components/registeration/Register Details";
import * as XLSX from "xlsx"; // Import XLSX library for Excel export
import Switch from "react-switch";

export default function Registeration() {
  const title = "Registered User Details";
  const [apistate, setApiState] = useState([]);
  const [apicol, setApiCol] = useState([]);
  const [selectVal, setSelectval] = useState([]);
  const [openModal, setOpenModal] = useState(true);
  const [selectVal_details, setSelectVal_details] = useState([]);
  const [details_modal_show, set_details_modal_Show] = useState(false);

  const [open_add_modal, setOpen_add_modal] = useState({
    render: true,
    modal_open: false,
  });

  const [open_update_modal, setOpen_update_modal] = useState({
    render: true,
    modal_open: false,
  });
  const [update_modal_data, setUpdate_modal_data] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [showRegisterDetailModal, setShowRegisterDetailModal] = useState(false);
  const [selectedRegister, setSelectedRegister] = useState(null);

  const brad = [
    {
      name: "Home",
    },
    {
      name: title,
    },
  ];

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "2-digit", day: "2-digit" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const columns = [
    {
      name: <b>Name</b>,
      selector: (row) => row.name,
      sortable: true,
    },
    {
      name: <b>Email</b>,
      selector: (row) => row.email,
      sortable: true,
    },
    {
      name: <b>Phone Number</b>,
      selector: (row) => row.phoneNumber,
      sortable: true,
    },
    {
      name: <b>Staff Type</b>,
      selector: (row) => row.generalStaffType,
      sortable: true,
    },
    {
      name: <b>Location</b>,
      selector: (row) => row.location,
      sortable: true,
    },
    {
      name: <b>IDFY Verified</b>,
      selector: (row) => row.idfyVerified,
      sortable: true,
      cell: (row) =>
        row.idfyVerified ? (
          <button
            style={{
              backgroundColor: "#198754", // green
              color: "white",
              border: "none",
              borderRadius: "8px",
              padding: "4px 12px",
              cursor: "default",
              fontWeight: "600",
            }}
          >
            YES
          </button>
        ) : (
          <button
            style={{
              backgroundColor: "#F44336", // red
              color: "white",
              border: "none",
              borderRadius: "4px",
              padding: "4px 12px",
              cursor: "default",
              fontWeight: "600",
            }}
          >
            NO
          </button>
        ),
    },
    {
      name: <b>Approved </b>,
      selector: (row) => (row.approved ? "True" : "False"),
      cell: (row) => (
        <Switch
          onChange={() => handleToggleApproved(row)}
          checked={row.approved}
        />
      ),
      sortable: true,
    },
    {
      name: <b>Approved By</b>,
      selector: (row) => (row.approvedBy ? row.approvedBy.name : "-"),
      sortable: true,
    },
    {
      name: <b>Created At</b>,
      selector: (row) => formatDate(row.createdAt),
      sortable: true,
    },
    {
      name: <b>Modified At</b>,
      selector: (row) =>
        row.updatedAt && new Date(row.updatedAt).toLocaleDateString(),
      sortable: true,
    },
    {
      name: <b>Action</b>,
      cell: (row) => (
        <>
          <button
            onClick={() => viewRegister(row)}
            className="btn btn-primary btn-sm ms-1"
          >
            <FontAwesomeIcon icon={faEye} />
          </button>
        </>
      ),
    },
  ];

  const handleShow = (row) => {
    setOpenModal(!openModal);
    setSelectval(row);
  };

  const fetchData = async (page) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }
      const response = await axios.get(
        `${process.env.REACT_APP_BASE_URL}/api/v1/user/joining-forms`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (Array.isArray(response.data.forms)) {
        setApiState(response.data.forms);
      } else {
        console.error("Unexpected data format from API", response.data);
      }
      setApiCol(columns);
    } catch (error) {
      console.log("Error fetching users:", error);
    }
  };

  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage]);

  const handleToggleApproved = async (row) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        console.error("No token found");
        return;
      }

      const updatedApproved = !row.approved;

      // Create FormData and append the updated Tracking value
      const formData = new FormData();
      formData.append("approved", updatedApproved);

      const response = await axios.post(
        `${process.env.REACT_APP_BASE_URL}/api/v1/user/joining-form/approve/${row._id}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        const updatedApproved = apistate.map((register) =>
          register._id === row._id
            ? { ...register, register: updatedApproved }
            : register
        );
        setApiState(updatedApproved);
        Swal.fire("Updated!", "Approved status has been updated.", "success");
      } else {
        Swal.fire(
          "Error!",
          "There was an error updating Approved status.",
          "error"
        );
      }
    } catch (error) {
      console.error("Error updating Approved status:", error);
      Swal.fire(
        "Error!",
        "There was an error updating Approved status.",
        "error"
      );
    }
  };

  const setStoreBtn = () => {
    setOpen_add_modal({ render: !open_add_modal.render, modal_open: true });
  };

  const setUpdateStoreBtn = (row) => {
    setOpen_update_modal({
      render: !open_update_modal.render,
      modal_open: true,
    });
    setUpdate_modal_data(row);
  };

  const copyLink = () => {
    alert(46);
  };

  const viewRegister = (register) => {
    setSelectedRegister(register);
    setShowRegisterDetailModal(true);
  };

  const exportToExcel = () => {
    const transformedData = apistate.map((register) => ({
      Name: register.name,
      Email: register.email,
      "Phone Number": register.phoneNumber,
      "Staff Type": register.generalStaffType,
      Location: register.location,
      Approved: register.approved,
      "IDFY Veirifed": register.idfyVerified,
      "Approved By": register.approvedBy?.name,
      "Created At": formatDate(register.createdAt),
    }));

    const worksheet = XLSX.utils.json_to_sheet(transformedData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Registers");

    XLSX.writeFile(workbook, "register.xlsx");
  };

  return (
    <>
      <Layouts />
      <Status_modal row={selectVal} openModal={openModal} />
      <RegisterDetailModal
        show={showRegisterDetailModal}
        onHide={() => setShowRegisterDetailModal(false)}
        register={selectedRegister}
      />

      <div className="container-fluid">
        <div className="row my-3">
          <div className="col-12">
            <div className="card" style={{ borderTop: "2px solid #4723d9" }}>
              <div className="card-header d-flex justify-content-between border-bottom pb-1">
                <h4>{title}</h4>
                <div>
                  <Link to="/create-register">
                    <div className="btn btn-info btn-sm text-white">
                      Add Registeration
                    </div>
                  </Link>
                  <button
                    onClick={exportToExcel}
                    className="btn btn-success btn-sm ms-2"
                  >
                    Export to Excel
                  </button>
                </div>
              </div>

              <div className="card-body">
                {apistate.length > 0 ? (
                  <DataTable_Component
                    searchBy="name"
                    apidata={apistate}
                    columns={apicol}
                  />
                ) : (
                  <p>Loading...</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
